import { useMutation, useQueryClient } from '@tanstack/react-query';

import { requireSuccess } from '../../shared';
import { addRecord, deleteNotStarted } from './pendingApi';
import { pendingKeys } from './queries';

const usePendingMutation = (mutationFn: (deviceIds: string[]) => Promise<any>) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (deviceIds: string[]) => requireSuccess(await mutationFn(deviceIds)),
        // Not returned on purpose: returning the promise would hold the caller's
        // onSuccess (the "added" / "deleted" snackbar) until the whole list has been
        // refetched. The refetch runs in the background with the old rows on screen.
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: pendingKeys.all });
        },
    });
};

/** Adds not-started records for `deviceIds`, then refetches the pending list. */
export const useAddRecord = () => usePendingMutation(addRecord);

/** Deletes the not-started records for `deviceIds`, then refetches the pending list. */
export const useDeleteNotStarted = () => usePendingMutation(deleteNotStarted);
